<div class="modal-container">
  <div class="canvas-modal">
    <div class="canvas-modal-body">
      <div class="flex items-center mb-2">
        <div class="flex-1">
          <span class="text-lg font-bold">{{ title }}</span>
        </div>
        <label class="cursor-pointer" (click)="close()">✕</label>
      </div>
      <hr class="mb-2" />
      <div class="canvas-modal-content">
        <ng-content></ng-content>
      </div>
    </div>
  </div>
  <div class="canvas-modal-background"></div>
</div>
